/* eslint-disable react-hooks/exhaustive-deps */
/*
 * Detection-feed sub-tab — live-ish stream of auto-detection events
 * (auto-bans, auto-unbans). Polls every 10 s while the tab is open.
 */
import { useEffect, useState, useRef } from "react";
import { api, apiError } from "@/lib/api";
import { Radio, RefreshCw } from "lucide-react";

export default function FeedTab({ toast }) {
  const [events, setEvents] = useState([]);
  const intervalRef = useRef(null);

  const load = async () => {
    try {
      const { data } = await api.get("/admin/moderation/detection-feed");
      setEvents(data.events || []);
    } catch (e) { toast.error(apiError(e)); }
  };

  useEffect(() => {
    load();
    intervalRef.current = setInterval(load, 10_000);
    return () => clearInterval(intervalRef.current);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const outcomeColour = (o) => {
    if (o === "banned") return "text-rose-300 bg-rose-500/15 border-rose-500/40";
    if (o === "auto_unbanned") return "text-emerald-300 bg-emerald-500/15 border-emerald-500/40";
    return "text-amber-300 bg-amber-500/15 border-amber-500/40";
  };

  return (
    <div className="glass-card p-4 space-y-3" data-testid="feed-list">
      <div className="flex items-center justify-between">
        <h3 className="label flex items-center gap-2"><Radio size={14} /> Detection Feed (last 100, auto-refresh 10s)</h3>
        <button onClick={load} className="btn btn-ghost text-xs"><RefreshCw size={12} /> Refresh</button>
      </div>
      {events.length === 0 ? (
        <p className="text-[var(--muted)] text-sm">No detection events yet. The autoban loop will populate this in real time when it catches a cheater.</p>
      ) : (
        <ul className="divide-y divide-white/5 max-h-[60vh] overflow-y-auto">
          {events.map((e) => (
            <li key={e.id} className="py-2 flex items-start gap-3 text-sm" data-testid={`feed-row-${e.id}`}>
              <span className={`text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded-full border ${outcomeColour(e.outcome)}`}>{e.outcome}</span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-mono text-[var(--bone)]">{e.player_name || e.player_id || "—"}</span>
                  {e.server ? <span className="text-xs text-[var(--muted)]">· {e.server}</span> : null}
                  <span className="text-xs text-[var(--muted)] font-mono ml-auto">{e.detected_at}</span>
                </div>
                {e.reason ? <p className="text-xs text-white/80 mt-0.5">{e.reason}</p> : null}
                {e.raw_line ? <p className="text-[10px] text-[var(--muted)] font-mono mt-0.5 truncate" title={e.raw_line}>{e.raw_line}</p> : null}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
